import moment from 'moment-timezone';
import { TZ } from '../../constants';
export default function TimeFormat({ time  }) {
  return moment(time).utc(false).tz(TZ).format('DD/MM/YYYY hh:mm A') + ' SGT' || "-"
}